import $ from "jquery";
import CONFIG from "@bd-core/config";

export const storyTelling = () => {
  $(document).ready(function () {
    if (CONFIG.siteSetup !== "stt") return;
  });
};
